import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import Money from "../../common/moneyComponent";
import RelationLink from "../relations/relationLink";
import OldStyleTableWithHistory from "../../common/oldStyleTableWithHistory";
import ResponsiveTable from "../../layoutItems/responsiveTable";

class Table extends React.Component {
    render() {
        if (this.props.data.length === 0)
            return null;

        return (
            <ResponsiveTable>
                <OldStyleTableWithHistory stripped noMargin tableColumns={7}
                    resolveExpanded={this.props.resolveExpanded}
                    head={() => <thead className="pub-procurements-header">
                        <tr>
                            <th style={{ width: "15.6%" }}><Translate id={this.props.column} /></th>
                            <th style={{ width: "10%" }}><Translate id="Report.Procurements.Ico" /></th>
                            <th style={{ width: "12%" }}><Translate id="Report.Procurements.EvidenceNumber" /></th>
                            <th style={{ width: "20.4%" }}><Translate id="Report.Procurements.ContractName" /></th>
                            <th style={{ width: "14%", textAlign: "right" }}><Translate id="Report.Procurements.ExpectedPrice" /></th>
                            <th style={{ width: "12%", textAlign: "right" }}><Translate id="Report.Procurements.FinalPrice" /></th>
                            <th style={{ width: "8%", textAlign: "right" }}><Translate id="Report.Procurements.ExposureDate" /></th>
                            <th style={{ width: "8%", textAlign: "right" }}><Translate id="Report.Nace.Source" /></th>                          
                        </tr>
                    </thead>}
                    actualData={this.props.data.map((s, i) => ({ ...s, index: i }))}
                    actualRow={(r) => <React.Fragment key={r.index}>
                        <tr className='colorize'>
                            <td data-label={this.props.translate(this.props.column)}><RelationLink reports={r.reports} entityName={r.subjectName} entityId={r.subjectId} showOnMobile={true} /></td>
                            <td data-label={this.props.translate('Report.Procurements.Ico')}>{r.companyId}</td>
                            <td data-label={this.props.translate('Report.Procurements.EvidenceNumber')} style={{ wordWrap: 'break-word'}}>{r.evidenceNumber || "-"}</td>
                            <td data-label={this.props.translate('Report.Procurements.ContractName')}>{r.contractName}</td>
                            <td data-label={this.props.translate('Report.Procurements.ExpectedPrice')} style={{ textAlign: "right" }}><Money fractionDigits={2} value={r.hasExpectedPrice ? r.ePrice : r.finalPrice}></Money></td>
                            <td data-label={this.props.translate('Report.Procurements.FinalPrice')} style={{ textAlign: "right" }}><Money fractionDigits={2} value={r.finalPrice} /></td>
                            <td data-label={this.props.translate('Report.Procurements.ExposureDate')} style={{ textAlign: "right" }}><span>{r.dateFormated}</span></td>
                            <td data-label={this.props.translate('Report.Nace.Source')} title={r.sourceDescription} style={{ textAlign: "right" }}><span>{r.sourceShortening}</span></td>
                            <td className="hide-on-desktop">{r.desc || "-"}</td>
                        </tr>
                        <tr className="hide-on-mobile">
                            <td></td>
                            <td colSpan="6">{r.desc || "-"}</td>
                        </tr>
                    </React.Fragment>}
                />
            </ResponsiveTable>
        )
    }
}

export default withLocalize((Table));